import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"

// TODO(i18n): centralize these labels (and JobTransitionButton labels / LOCK_TOOLTIP) when the FE i18n sweep lands.
const STATUS_CONFIG = {
  not_started: {
    label: "Not Started",
    color: "gray",
    dotColor: "bg-gray-500",
  },
  in_progress: {
    label: "In Progress",
    color: "blue",
    dotColor: "bg-blue-500",
  },
  on_hold: {
    label: "On Hold",
    color: "yellow",
    dotColor: "bg-yellow-500",
  },
  completed: {
    label: "Work Complete",
    color: "supplementary-violet",
    dotColor: "bg-supplementary-violet-500",
  },
  invoiced: {
    label: "Invoiced",
    color: "teal",
    dotColor: "bg-teal-500",
  },
}

const JobStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status]
  if (!config) return null

  return (
    <Badge
      variant="small"
      color={config.color}
      text={
        <span className="inline-flex items-center gap-2">
          <span
            className={classNames("h-2 w-2 rounded-full", config.dotColor)}
            aria-hidden="true"
          />
          {config.label}
        </span>
      }
    />
  )
}

JobStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
}

export const JOB_STATUS_CONFIG = STATUS_CONFIG

export default JobStatusBadge
